import { useRef, useEffect } from 'react';
import styles from './TableMenu.module.scss.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Link } from '../../link/Link.js';
import { UNSAFE_Icon } from '../../icon/Icon.js';
import { Text } from '../../text/Text.js';
import classNames from 'clsx';
import { MdCheck } from '../../node_modules/react-icons/md/index.js';

function TableMenuItem(props) {
  const {
    active,
    children,
    disabled,
    href,
    hrefType,
    icon,
    rel,
    secondary,
    selected,
    shortcut,
    size,
    tag,
    target,
    value,
    variant = 'default',
    onClick,
    onSelect
  } = props;
  const ref = useRef(null);
  const className = classNames(styles['item'], disabled && styles['disabled'], active && styles['focus'], styles[`variant-${variant}`], styles[`size-${size}`]);
  useEffect(() => {
    if (active) {
      ref.current?.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [active]);
  function handleSelect(e) {
    if (!disabled) {
      onClick?.(e);
      onSelect(value);
    }
  }
  const content = /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: styles['col'],
      children: (selected || icon) && /*#__PURE__*/jsxs("div", {
        className: styles['icon-start'],
        children: [selected && /*#__PURE__*/jsx("span", {
          children: /*#__PURE__*/jsx(UNSAFE_Icon, {
            icon: MdCheck
          })
        }), icon && /*#__PURE__*/jsx("span", {
          children: /*#__PURE__*/jsx(UNSAFE_Icon, {
            icon: icon
          })
        })]
      })
    }), /*#__PURE__*/jsxs("div", {
      className: styles['col'],
      children: [/*#__PURE__*/jsx(Text, {
        variant: size === 'small' ? 'menu-item-small' : 'menu-item',
        children: children
      }), secondary != null && /*#__PURE__*/jsx(Text, {
        className: styles['secondary'],
        variant: size === 'small' ? 'menu-description-small' : 'menu-description',
        children: secondary
      })]
    }), /*#__PURE__*/jsx("div", {
      className: styles['col'],
      children: shortcut != null && /*#__PURE__*/jsx(Text, {
        className: styles['shortcut'],
        variant: size === 'small' ? 'menu-shortcut-small' : 'menu-shortcut',
        children: shortcut
      })
    }), /*#__PURE__*/jsx("div", {
      className: styles['col']
    })]
  });
  return href ? /*#__PURE__*/jsx(Link, {
    className: className,
    href: href,
    hrefType: hrefType,
    rel: rel,
    ref: ref,
    target: target,
    onClick: handleSelect,
    "data-dsx--menu-item": tag,
    children: content
  }) : /*#__PURE__*/jsx("div", {
    className: className,
    ref: ref,
    role: "menuitem",
    tabIndex: -1,
    onClick: handleSelect,
    "data-dsx--menu-item": tag,
    children: content
  });
}

export { TableMenuItem };
